import {
	BulkPatchPaymentDto,
	BulkUpdatePaymentRes,
	GetPaymentRes,
	PatchPaymentDto,
} from '@dealstack/shared/lib/generated';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import { ServiceRequestOptions } from '@dealstack/frontend/shared/other/react/ApiWrapper/types';
import { CONTENT_TYPE, HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { Response } from '@dealstack/shared/lib/common/dataExchange/apiV1';

export const getMipPaymentsData = async (_args: void, options?: ServiceRequestOptions) => {
	const response = await makeRequest<Response<GetPaymentRes>>(
		{ endpoint: API_PATHS.MIP_PAYMENT_GET, method: HTTP_METHOD.GET },
		{ ...options }
	);
	return response;
};

export const downloadMipPayments = async (_args: void, options?: ServiceRequestOptions) => {
	const response = await makeRequest<Blob>(
		{
			endpoint: API_PATHS.MIP_PAYMENT_BULK_DOWNLOAD_GET,
			method: HTTP_METHOD.GET,
			customHeaders: {
				Accept: CONTENT_TYPE.ZIP,
			},
		},
		{ ...options }
	);
	return response;
};

export const updateMipPaymentData = async (
	args: Partial<PatchPaymentDto> & {
		id: string;
	},
	options?: ServiceRequestOptions
) => {
	const response = await makeRequest<Response<GetPaymentRes>>(
		{
			endpoint: formatUnicorn(API_PATHS.MIP_PAYMENT_ID_PATCH, {
				id: args.id,
			}),
			method: HTTP_METHOD.PATCH,
			body: JSON.stringify({
				status: args.status,
				annotation: args.annotation,
			}),
		},
		{ ...options }
	);
	return response;
};

export const bulkUpdateMipPaymentData = async (
	args: BulkPatchPaymentDto,
	options?: ServiceRequestOptions
) => {
	const response = await makeRequest<Response<BulkUpdatePaymentRes>>(
		{
			endpoint: API_PATHS.MIP_PAYMENT_BULK_PATCH,
			method: HTTP_METHOD.PATCH,
			body: JSON.stringify(args),
		},
		{ ...options }
	);
	return response;
};
